import SubmitLead from "../components/SubmitLead/SubmitLead";
import sendRequest from "../hooks/useAxios";
import { useState, useEffect } from "react";
import LeadList from "../components/SubmitLead/LeadList";
import Loader from "../utilities/Loader";
export default function SubmitLeadPage() {
  const customerType = [
    { label: "فروشنده", id: "seller", index: 1 },
    { label: "تولیدکننده", id: "producer", index: 2 },
    { label: "واردات", id: "imports", index: 3 },
    { label: "صادرات", id: "exports", index: 4 },
  ];
  const leadReason = [
    {
      label: "تبلیغات",
      id: "advertising",
      index: 1,
    },
    {
      label: "بسته بندی",
      id: "packing",
      index: 2,
    },
    {
      label: "فروش",
      id: "sell",
      index: 3,
    },
  ];
  const operatorList = [
    { label: "مهندس کوهرخی", value: "1" },
    // { label: "خانم عسگری", value: "2" },
    { label: "خانم خلیل", value: "3" },
    { label: "نثاری", value: "5" },
    { label: "شیرازی", value: "6" },
    { label: "سایر", value: "4" },
  ];
  const [updater, setUpdater] = useState(false);
  const [leadList, setLeadList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    sendRequest("?action=get_leads").then((data) => {
      setLoading(true);
      if (data.data.state == 1) {
        setLoading(false);
        setLeadList(data.data.result);
      }
    });
  }, [updater]);

  return loading ? (
    <Loader />
  ) : (
    <div>
      <SubmitLead
        customerType={customerType}
        leadReason={leadReason}
        operatorList={operatorList}
        setUpdater={setUpdater}
        setLoading={setLoading}
      />
      <LeadList
        leadListData={leadList}
        customerType={customerType}
        leadReason={leadReason}
        operatorList={operatorList}
      />
    </div>
  );
}
